import React, { useEffect } from "react";

import Payouts from "./Payouts";
import OwnliScreenWrapper from "../ownli/OwnliScreenWrapper";
import RewardsSummary from "./RewardsSummary";
import analyticsService from "../../lib/AnalyticsService";

const Reward = ({ customer: propCustomer }) => {
  useEffect(() => {
    analyticsService.trackPageView("insurance_rewards_summary", {});
  }, []);

  return (
    <OwnliScreenWrapper>
      <div className="max-w-3xl mx-auto space-y-6">
        <RewardsSummary />
        <Payouts />
      </div>
    </OwnliScreenWrapper>
  );
};

export default Reward;
